import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { AwardToggle } from 'components/layout'
import { AWARD_LEVELS } from 'constants/enums'
import styles from './award-sub-header.styl'

import medalBlank from 'assets/img/badges/medal-blank.svg'
import medalBronze from 'assets/img/badges/medal-bronze.svg'
import medalSilver from 'assets/img/badges/medal-silver.svg'
import medalGold from 'assets/img/badges/medal-gold.svg'

export default class AwardSubHeader extends Component {
  static propTypes = {
    hills: PropTypes.bool,
    medal: PropTypes.bool,
    awardId: PropTypes.number,
    awardLevel: PropTypes.object,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    awards: PropTypes.object,
    bronzeMedalUrl: PropTypes.string,
    silverMedalUrl: PropTypes.string,
    goldMedalUrl: PropTypes.string
  }

  static defaultProps = {
    hills: false,
    medal: null
  }

  render() {
    const { medal, title, hills, subtitle, awardLevel, awards,
      bronzeMedalUrl, silverMedalUrl, goldMedalUrl } = this.props

    const classNames = [styles.wrap]
    const hasMultiple = awards.list.length > 1

    hills && classNames.push(styles.hills)
    hasMultiple && classNames.push(styles.hasMultiple)

    let medalBadgeSrc = null

    if (medal === 'blank') {
      medalBadgeSrc = medalBlank
    } else {
      switch (get(awardLevel, 'value')) {
        case AWARD_LEVELS.bronze.id:
          medalBadgeSrc = bronzeMedalUrl || medalBronze
          break
        case AWARD_LEVELS.silver.id:
          medalBadgeSrc = silverMedalUrl || medalSilver
          break
        case AWARD_LEVELS.gold.id:
          medalBadgeSrc = goldMedalUrl || medalGold
          break
        default:
          break
      }
    }

    const medalBadge = (
      <img
        src={medalBadgeSrc}
        alt='Menu badge'
        className={styles.badge}
      />
    )


    return (
      <div className={classNames.join(' ')}>

        {medal && medalBadge}

        <div className={styles.content}>
          <p className={styles.title}>{title || <span>---</span>}</p>
          <p className={styles.subtitle}>{subtitle || <span>---</span>}</p>
        </div>

        {hasMultiple &&
          <AwardToggle awardsList={awards.list} awardId={this.props.awardId} />}
      </div>
    )
  }
}
